import React from "react";
import "./FaqSection.css";

/**
 * Visible FAQ rendered from the same schema.org FAQPage object that is emitted
 * as JSON-LD (src/seo/pageMeta.js), so the on-page text and the structured data
 * can never drift apart. Uses native <details> so every answer is in the
 * prerendered HTML for crawlers that do not run JavaScript.
 */
const FaqSection = ({ faq, heading = "Frequently asked questions" }) => (
  <section className="faq-section" aria-labelledby="faq-heading">
    <div className="faq-inner">
      <h2 id="faq-heading" className="faq-heading">{heading}</h2>
      {faq.mainEntity.map((q) => (
        <details className="faq-item" key={q.name}>
          <summary>{q.name}</summary>
          <p>{q.acceptedAnswer.text}</p>
        </details>
      ))}
    </div>
  </section>
);

export default FaqSection;
